// extracted by mini-css-extract-plugin
export default {"container":"no-results-message__container___M32mV","text":"no-results-message__text___W6A7w"};